import React, {
    useContext, useMemo
} from 'react';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import _ from 'lodash';
import { TranslatorContext } from '@jutro/locale';
import metadata from './SgCoverageChangesSummary.metadata.json5';
import messages from './SgCoverageChangesSummary.messages';

function SgCoverageChangesSummary(props) {
    const {
        changes,
    } = props;

    const translator = useContext(TranslatorContext);

    const coveragesAdded = useMemo(() => {
        let coveragesAddedString = '';
        _.each(changes.coverageAdded, (coverage, index) => {
            if (index > 0) {
                coveragesAddedString += ', ';
            }
            coveragesAddedString += coverage.name;
        });
        return coveragesAddedString;
    }, [changes.coverageAdded]);

    const coveragesRemoved = useMemo(() => {
        let coveragesRemovedString = '';
        _.each(changes.coverageRemoved, (coverage, index) => {
            if (index > 0) {
                coveragesRemovedString += ', ';
            }
            coveragesRemovedString += coverage.name;
        });
        return coveragesRemovedString;
    }, [changes.coverageRemoved]);

    const overrideProps = {
        coverageAdded: {
            visible: !_.isNil(changes.coverageAdded),
            content: !_.isNil(changes.coverageAdded)
                ? (
                    <>
                        {translator(messages.CoverageAdded, { coverage: <p>{ coveragesAdded }</p> })}
                    </>
                ) : null
        },
        coverageRemoved: {
            visible: !_.isNil(changes.coverageRemoved),
            content: !_.isNil(changes.coverageRemoved)
                ? (
                    <>
                        {translator(messages.CoverageRemoved, { coverage: <p>{ coveragesRemoved }</p> })}
                    </>
                ) : null
        },
        breakdownCoverLevel: {
            visible: !_.isNil(changes.breakdownCoverLevel),
            content: !_.isNil(changes.breakdownCoverLevel)
                ? (
                    <>
                        {translator(messages.Changed)}
                        <p>{translator(messages.BreakdownCoverChanged, { coverLevel: changes.breakdownCoverLevel })}</p>
                    </>
                ) : null
        },
        voluntaryExcess: {
            visible: !_.isNil(changes.voluntaryExcess),
            content: !_.isNil(changes.voluntaryExcess)
                ? (
                    <>
                        {translator(messages.Changed)}
                        <p>{translator(messages.VoluntaryExcessChanged, { excess: changes.voluntaryExcess })}</p>
                    </>
                ) : null
        },
        pncdPrice: {
            visible: !_.isNil(changes.pncdPrice),
            content: !_.isNil(changes.pncdPrice)
                ? (
                    <>
                        {translator(messages.Changed)}
                        <p>{translator(messages.PNCDPriceChanged, { amount: changes.pncdPrice })}</p>
                    </>
                ) : null
        }
    };

    const resolvers = {
        resolveCallbackMap: {},
        resolveComponentMap: {}
    };

    return renderContentFromMetadata(metadata.componentContent, overrideProps, resolvers);
}

export default SgCoverageChangesSummary;
